import { render, staticRenderFns } from "./zizi.vue?vue&type=template&id=3b71667b&scoped=true&"
import script from "./zizi.vue?vue&type=script&lang=js&"
export * from "./zizi.vue?vue&type=script&lang=js&"
import style0 from "./zizi.vue?vue&type=style&index=0&id=3b71667b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b71667b",
  null
  
)

export default component.exports